module.exports = __webpack_public_path__ + "img/pause-component-icon.db6f4d27.svg";